import React from 'react';

export default function Skills() {
  return (
    <section
      id="skills"
      data-aos="fade-up"
      className="py-20 px-6 bg-gray-50 text-gray-800 scroll-mt-24"
    >
      <div className="max-w-4xl mx-auto transform text-left transition duration-300 hover:scale-[1.01] hover:shadow-xl bg-white rounded-xl p-6">
        
        <h2 className="text-3xl font-bold mb-6 text-center w-full transition-colors duration-300 hover:text-green-700">
          Technical Expertise
        </h2>

        {/* Two-Column Layout */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">

          {/* Skills */}
          <div>
            <h3 className="text-2xl font-semibold mb-4">Core Competencies</h3>
            <ul className="list-disc ml-6 space-y-2 text-lg">
              <li>Library Automation Systems: KOHA, DSpace, EPrints</li>
              <li>Knowledge Organization & Information Retrieval</li>
              <li>Metadata Curation & Semantic Modeling</li>
              <li>Programming: Python, JavaScript</li>
              <li>Web Development: React, Flask, TailwindCSS</li>
              <li>Databases & Graph Technologies: PostgreSQL, Neo4j</li>
            </ul>
          </div>

          {/* Certifications - Upgraded to Card Grid */}
          <div>
            <h3 className="text-2xl font-semibold mb-4">
              Professional Certifications
            </h3>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {[
                "Neo4j Certified Professional",
                "Neo4j Graph Data Science",
                "Cypher Fundamentals",
                "Data Visualization with Plotly",
                "Library Automation using KOHA & DSpace",
              ].map((cert, index) => (
                <div
                  key={index}
                  data-aos="fade-up"
                  data-aos-delay={index * 100}
                  className="p-4 bg-white border border-gray-200 rounded-lg shadow-sm transition duration-300 hover:shadow-md hover:scale-[1.02]"
                >
                  <p className="text-sm font-medium text-gray-700">
                    {cert}
                  </p>
                </div>
              ))}
            </div>
          </div>

        </div>

        {/* Technical Stack Snapshot - Animated Badges */}
        <div className="mt-12">
          <h3 className="text-xl font-semibold mb-4 text-center">
            Technical Stack Snapshot
          </h3>

          <div className="flex flex-wrap justify-center gap-3">
            {[
              "Python",
              "Neo4j",
              "Graph Data Science",
              "React",
              "Flask",
              "Koha",
              "Semantic Modeling",
            ].map((tag, index) => (
              <span
                key={index}
                data-aos="fade-up"
                data-aos-delay={index * 80}
                className="px-4 py-2 bg-emerald-100 text-emerald-700 rounded-full text-sm font-medium transition duration-300 hover:bg-emerald-200 hover:scale-[1.05]"
              >
                {tag}
              </span>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
}
